import { useLocation } from '@remix-run/react'
import { useEffect } from 'react'

const gtmTrackingId = 'GTM-PMLQ9Z3'

export function ExternalScripts(props: {}) {
  const location = useLocation()
  let added = false

  // CUSTOM IMPLEMENTATION OF GTM (NEEDS TO RUN ON CLIENT SIDE ONLY)
  // Example (has hydration issues): https://github.com/remix-run/examples/tree/main/google-analytics
  // Issue: https://github.com/remix-run/examples/issues/74
  useEffect(() => {
    const gtmScript = document.createElement('script')

    gtmScript.innerHTML = `
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
              'gtm.start': new Date().getTime(),
              event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src =
              'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmTrackingId}');`

    // Prevents twice additions
    if (!added) {
      document.head.appendChild(gtmScript)
      // eslint-disable-next-line react-hooks/exhaustive-deps
      added = true
    }

    // Not sure if this is needed
    return () => {
      try {
        document.head.removeChild(gtmScript)
      } catch (error) {
        // silence errors on 404 or 500
      }
    }
  }, [location])

  return (
    <>
      {/* GOOGLE TAG MANAGER NOSCRIPT */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${gtmTrackingId}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  )
}
